import { forwardRef } from "react";
import type { LinkComponentProps } from "../../types/link";

export const DefaultLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(
  // prefetch と discover は react-router の Link だけが読む。素の a に流すと知らない属性として HTML に残る
  ({ to, children, prefetch: _prefetch, discover: _discover, ...props }, ref) => (
    <a href={to} ref={ref} {...props}>
      {children}
    </a>
  )
);

DefaultLink.displayName = "DefaultLink";
